"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.initialiseControlComponent = initialiseControlComponent;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _logger = require("@insided/shared/services/logger");

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _ControlProviders = _interopRequireDefault(require("./ControlProviders"));

function tryLoadingComponent(_x) {
  return _tryLoadingComponent.apply(this, arguments);
}

function _tryLoadingComponent() {
  _tryLoadingComponent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(componentName) {
    var imports, _i, _imports, imp;

    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            imports = [/*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return import(
                      /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
                      'control-components/' + componentName + '.tsx');

                    case 2:
                      return _context.abrupt("return", _context.sent);

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })), /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
              return _regenerator.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return import(
                      /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
                      'control-components/' + componentName + '.sync.tsx');

                    case 2:
                      return _context2.abrupt("return", _context2.sent);

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })), /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
              return _regenerator.default.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return import(
                      /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
                      'control-components/' + componentName + '.js');

                    case 2:
                      return _context3.abrupt("return", _context3.sent);

                    case 3:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            })), /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
              return _regenerator.default.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return import(
                      /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
                      'control-components/' + componentName + '.sync.js');

                    case 2:
                      return _context4.abrupt("return", _context4.sent);

                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            })), /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
              return _regenerator.default.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return import(
                      /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
                      'control/modules/' + componentName + '.tsx');

                    case 2:
                      return _context5.abrupt("return", _context5.sent);

                    case 3:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            }))];
            _i = 0, _imports = imports;

          case 2:
            if (!(_i < _imports.length)) {
              _context6.next = 17;
              break;
            }

            imp = _imports[_i];
            _context6.prev = 4;
            _context6.next = 7;
            return imp();

          case 7:
            return _context6.abrupt("return", _context6.sent.default);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](4);

            if (!(_context6.t0.code !== 'MODULE_NOT_FOUND')) {
              _context6.next = 14;
              break;
            }

            throw _context6.t0;

          case 14:
            _i++;
            _context6.next = 2;
            break;

          case 17:
            throw new Error("Component ".concat(componentName, " not found"));

          case 18:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[4, 10]]);
  }));
  return _tryLoadingComponent.apply(this, arguments);
}

function _initialiseControlComponent(_x2, _x3, _x4) {
  return _initialiseControlComponent2.apply(this, arguments);
}

function _initialiseControlComponent2() {
  _initialiseControlComponent2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(componentName, el, params) {
    var _user$email, _user$avatar;

    var unrender,
        child,
        LoadedComponent,
        user,
        userContextValue,
        appState,
        result,
        _args8 = arguments;
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            unrender = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : false;
            child = el.firstChild;

            if (!unrender) {
              _context8.next = 5;
              break;
            }

            (0, _preact.render)('', el, child);
            return _context8.abrupt("return", null);

          case 5:
            _context8.next = 7;
            return tryLoadingComponent(componentName);

          case 7:
            LoadedComponent = _context8.sent;
            (0, _translations.addTranslationDict)(params.phrases || params.translations);
            params.parentEl = el;
            user = (0, _insidedDataStorage.getInsidedData)('user');
            userContextValue = {
              id: user.userid ? parseInt(user.userid) : null,
              email: (_user$email = user.email) !== null && _user$email !== void 0 ? _user$email : '',
              rank: user.rank,
              rankName: '',
              name: user.name,
              role: user.role,
              mainRole: user.mainRole,
              avatar: (_user$avatar = user.avatar) !== null && _user$avatar !== void 0 ? _user$avatar : '',
              rankIcon: '',
              loginSource: user.loginSource,
              registerSource: user.registerSource,
              isModerator: false,
              pmUnreadCount: 0,
              pmTotalCount: 0,
              topicsCount: 0,
              repliesCount: 0,
              solvedCount: 0,
              joindate: 0,
              likes: 0,
              likes_given: 0,
              profileFields: [],
              badges: []
            };

            if (LoadedComponent) {
              _context8.next = 14;
              break;
            }

            return _context8.abrupt("return", null);

          case 14:
            appState = (0, _globals.default)('appState');
            result = (0, _preact.render)((0, _preact.h)(_ControlProviders.default, {
              modules: (0, _globals.default)('activeModules') || [],
              translationContext: {
                getUsedTranslations: function getUsedTranslations() {
                  return {};
                },
                translations: params.phrases || params.translations || null,
                registerPhrase: function registerPhrase() {},
                language: (0, _globals.default)('communityLanguage')
              },
              userContext: userContextValue,
              appState: appState
            }, (0, _preact.h)(LoadedComponent, params)), el, child);

            if (module.hot) {
              module.hot.accept( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
                var LoadedComponent;
                return _regenerator.default.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return tryLoadingComponent(componentName);

                      case 2:
                        LoadedComponent = _context7.sent;
                        (0, _preact.render)((0, _preact.h)(LoadedComponent, params), el, child);

                      case 4:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              })));
            }

            return _context8.abrupt("return", result);

          case 18:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _initialiseControlComponent2.apply(this, arguments);
}

function initialiseControlComponent(_x5, _x6, _x7) {
  return _initialiseControlComponent3.apply(this, arguments);
}

function _initialiseControlComponent3() {
  _initialiseControlComponent3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(componentName, el, params) {
    var unrender,
        _args9 = arguments;
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            unrender = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : false;
            _context9.prev = 1;
            _context9.next = 4;
            return _initialiseControlComponent(componentName, el, params, unrender);

          case 4:
            return _context9.abrupt("return", _context9.sent);

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](1);

            _logger.logger.error(_context9.t0, {
              app: 'control',
              component: componentName,
              phase: 'control-init'
            });

            return _context9.abrupt("return", null);

          case 11:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[1, 7]]);
  }));
  return _initialiseControlComponent3.apply(this, arguments);
}

var _default = initialiseControlComponent;
exports.default = _default;